import type { ColumnDef } from "@tanstack/react-table"

export function findColumn<TData extends object>(identifier: string, columns: ColumnDef<TData>[]) {
  return columns.find((c) => {
    if ("accessorKey" in c && c.accessorKey === identifier) {
      return true
    }
    return c.id === identifier
  })
}

export function findColumnIndex<TData extends object>(
  identifier: string,
  columns: ColumnDef<TData>[]
) {
  const col = findColumn(identifier, columns)
  if (!col) return -1
  return columns.indexOf(col)
}
